import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  for: "file-activity",
  class: "border border-slate-300 flex flex-col gap-2 items-center justify-center h-28 my-2 rounded-md bg-white"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "text-base text-h-primary-500" }, /*#__PURE__*/_toDisplayString("Selecionar arquivo para enviar"), -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "border h-40 p-4 flex flex-col gap-2 justify-center my-2 rudend-md bg-white min-w-[300px]" }
const _hoisted_5 = { class: "flex flex-row items-start justify-between" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", { class: "text-sm font-normal text-h-neutral-500" }, /*#__PURE__*/_toDisplayString("Arquivo selecionado:"), -1)
const _hoisted_7 = {
  for: "more-files",
  class: "flex flex-row justify-between"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "flex flex-row gap-4 items-center px-4" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-plus",
    style: {"font-size":"0.7rem"}
  }),
  /*#__PURE__*/_createElementVNode("p", null, /*#__PURE__*/_toDisplayString("Arquivo"))
], -1)
const _hoisted_9 = { class: "overflow-auto min-h-96 flex flex-col gap-2" }
const _hoisted_10 = { class: "flex-1 text-h-primary-500 text-sm" }
const _hoisted_11 = { class: "flex-1 text-h-primary-500 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (!_ctx.fileActivity && _ctx.materials?.length === 0)
    ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
        _createVNode(_component_v_icon, {
          name: "md-uploadfile",
          scale: 2,
          class: "text-h-primary-500"
        }),
        _hoisted_2,
        _createElementVNode("input", {
          type: "file",
          id: "file-activity",
          class: "hidden",
          multiple: "",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args)))
        }, null, 32)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("label", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("input", {
                type: "file",
                id: "more-files",
                class: "hidden",
                multiple: "",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addMoreFiles && _ctx.addMoreFiles(...args)))
              }, null, 32)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileActivity, (file, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-row gap-3 bg-h-primary-50 p-4 rounded-md min-w-[270px]",
                key: index
              }, [
                _createVNode(_component_v_icon, {
                  name: "io-image-sharp",
                  class: "text-h-primary-500"
                }),
                _createElementVNode("p", _hoisted_10, _toDisplayString(file?.name), 1),
                _createVNode(_component_v_icon, {
                  name: "md-close",
                  class: "text-h-primary-500 cursor-pointer",
                  onClick: ($event: any) => (_ctx.unselectFile(index))
                }, null, 8, ["onClick"])
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materials, (material) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-row gap-3 bg-h-primary-50 p-4 rounded-md min-w-[270px]",
                key: material.id
              }, [
                _createVNode(_component_v_icon, {
                  name: "io-image-sharp",
                  class: "text-h-primary-500"
                }),
                _createElementVNode("p", _hoisted_11, _toDisplayString(material?.name + "." + material?.mimetype), 1),
                _createVNode(_component_v_icon, {
                  name: "md-close",
                  class: "text-h-primary-500 cursor-pointer",
                  onClick: ($event: any) => (_ctx.unselectMaterial(material?.id))
                }, null, 8, ["onClick"])
              ]))
            }), 128))
          ])
        ])
      ]))
}